<template>
  <div class="product-list">
    <component
      :is="componentName(item)"
      v-for="(item, index) in items"
      :key="getId(item, index)"
      :item="item"
    />
  </div>
</template>

<script>
import themeSettings from '../mixins/themeSettings'

export default {
  name: 'product-catalog-list-view',
  mixins: [themeSettings],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  mounted: function() {
    this.$store.dispatch('products/currentStock')
  },
  methods: {
    componentName(item) {
      if (item.node_type) {
        // const defaultLayout = `${item.node_type.replace(/[_\s]/, '-')}-list-item-0001`
        const defaultLayout = `wine-product-list-item-0001`
        const themeChoiceAvailable = (this.themeSettings && this.themeSettings !== null && Object.keys(this.themeSettings).includes('products') && this.themeSettings.products['catalogue-list'])

        return (themeChoiceAvailable) ? `${this.themeSettings.products['catalogue-list']}` : defaultLayout
      }

      return 'generic-product-list-item'
    },
    getId(item, index) {
      if (item.id != null) return item.id
      else if (item.nid != null) return item.nid
      else return index
    }
  }
}
</script>

<style scoped lang="scss">

</style>
